import { Empty, Form } from 'antd';
import { useContext } from 'react';

import { SListItemCard } from 'app/components/StaycationUI/List/SListItemCard/SListItemCard';
import { computeExperienceName } from 'app/components/commons/Experience/utils';
import { PictureList } from 'app/components/commons/ImageUploader/PictureList/PictureList';
import {
  pictureToPictureView,
  pictureViewToPicture,
} from 'app/components/pages/Experiences/Common/_components/Medias/_components/utils';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { Picture } from 'app/typings';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { PackResponse } from 'app/typings/core/admin/packs/pack';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import './ExperienceListItem.scss';

export const ExperienceListItem = ({
  experience,
  onToggle,
  packExperienceIndex,
}: {
  experience: ExperienceResponse;
  onToggle: (value: boolean) => void;
  packExperienceIndex: number;
}) => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const { data: experienceCategories } = useExperiencesCategories();

  const form = Form.useFormInstance<
    Partial<PackResponse> & { experiences: ExperienceResponse[] }
  >();
  const packExperiences = Form.useWatch('packExperiences', form);

  const packExperience = packExperiences?.find(
    (packXp) => packXp.experienceId === experience.id
  );

  const experienceName = computeExperienceName({
    category: experienceCategories?.find(
      (cat) => cat.id === experience?.categoryId
    ),
    quantity: null,
    brand: experience?.brand || null,
    duration: experience?.duration || null,
    durationDescription: experience?.durationDescription || null,
    time: experience?.time || null,
    locations: experience?.location || null,
  });

  const experienceTitle = (
    <div className="staycation-discover-experience-item_title">
      {experienceName}
    </div>
  );

  return (
    <SListItemCard
      itemId={experience.id}
      checked={packExperience?.discover ?? false}
      onToggle={onToggle}
      title={experienceTitle}
      displayDragHandle={false}
      disableToggle={!isEditMode}
      children={
        <Form.Item
          name={
            packExperienceIndex >= 0
              ? ['packExperiences', packExperienceIndex, 'pictures']
              : undefined
          }
          valuePropName="value"
          getValueProps={(value: PictureView[]) => ({
            value: (value ?? []).map(pictureViewToPicture),
          })}
          getValueFromEvent={(pictures: Picture[]) =>
            pictures.map(pictureToPictureView)
          }
        >
          {packExperience?.pictures ? (
            <PictureList
              pictures={packExperience.pictures.map(pictureViewToPicture)}
              uploadingItems={{}}
              previewable
            />
          ) : (
            <span className="empty-list">
              <Empty />
            </span>
          )}
        </Form.Item>
      }
    />
  );
};
